import { JSONSchema7 } from 'json-schema';
import JSONSchema7Properties from '../../../Shared/jSONSchema7Properties';

export default (currVer: JSONSchema7): JSONSchema7 => {
  let properties = currVer.properties as JSONSchema7Properties;

  properties = {
    ...properties,
    version: {
      $id: `${currVer.$id}/version`,
      default: 1,
      type: 'number'
    }
  };

  return {
    ...currVer,
    properties
  };
};
